module.exports = __webpack_public_path__ + "img/1960er-Frankfurter-Buchmesse.15193e85.jpg";